export const base64ToArrayBuffer = (base64) => {
  const binaryString = globalThis.atob(base64);
  const binaryLen = binaryString.length;
  const bytes = new Uint8Array(binaryLen);
  for (let i = 0; i < binaryLen; i++) {
    const ascii = binaryString.codePointAt(i);
    bytes[i] = ascii;
  }
  return bytes;
};

export const downloadItem = ({ fileName, fileType, content }) => {
  if (!content.length) {
    return;
  }
  const blob = new Blob([base64ToArrayBuffer(content)], {
    type: fileType,
  });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(link.href);
};
